import { CdkVirtualScrollViewport, ScrollingModule } from '@angular/cdk/scrolling';
import { NvTooltipModule } from 'Src/ng2/shared/nv-tooltip/nv-tooltip.module';
import { CdkTableModule } from '@angular/cdk/table';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { NetworkDashboardRollupTableComponent } from './network-dashboard-rollup-table.component';
import { TableSorter } from './pipes/table-sorter/table-sorter.pipe';
import { CellFormatter } from './pipes/cell-formatter/cell-formatter.pipe';
import { JsonDecode } from './pipes/json-decode/json-decode.pipe';

@NgModule({
  imports: [CommonModule, CdkTableModule, NvTooltipModule, ScrollingModule],
  declarations: [NetworkDashboardRollupTableComponent, TableSorter, CellFormatter, JsonDecode],
  providers: [TableSorter, CellFormatter, JsonDecode, ScrollingModule, CdkVirtualScrollViewport],
  exports: [NetworkDashboardRollupTableComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class NetworkDashboardRollupTableModule {
  /** */
}
